class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this._loading = false;
    this._observer = null;
  }

  connectedCallback() {
    const type = this.getAttribute('type') || 'load_more';
    const btn = this.querySelector('button');

    if (btn) {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.load();
      });
    }

    if (type === 'infinite') {
      this._observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.load();
        }
      }, { rootMargin: '200px 0px 200px 0px' });

      this._observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  async load() {
    if (this._loading) return;
    this._loading = true;

    const btn = this.querySelector('button');
    const spinnerEl = this.querySelector('.loading__spinner');

    if (btn) btn.classList.add('loading');
    if (spinnerEl) spinnerEl.classList.remove('hidden');

    const action = this.getAttribute('action') || '';
    const grid = document.getElementById('product-grid');
    const sectionId = grid?.dataset?.id || '';

    const url = new URL(action, window.location.origin);
    if (sectionId) url.searchParams.set('section_id', sectionId);

    try {
      const res = await fetch(url.toString());
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const nextGrid = doc.getElementById('product-grid');
      const wrapper = this.closest('.pagination-wrapper');

      if (nextGrid && grid) {
        const items = Array.from(nextGrid.children);
        for (const item of items) grid.appendChild(item);
      }

      const newWrapper = doc.querySelector('.pagination-wrapper');
      if (wrapper && newWrapper) {
        wrapper.innerHTML = newWrapper.innerHTML;
      } else if (wrapper && !newWrapper) {
        wrapper.remove();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this._loading = false;
      if (this.isConnected) {
        if (btn) btn.classList.remove('loading');
        const s = this.querySelector('.loading__spinner');
        if (s) s.classList.add('hidden');
      }
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);